export const leftChevron = "/static/images/left-chevron.svg"
export const plusIcon = "/static/images/plus-icon.svg"
export const closeIcon = "/static/images/close-icon.svg"
export const checkIcon = "/static/images/check-icon.svg"
export const enterIcon = "/static/images/enter-icon.svg"
export const refreshIcon = "/static/images/refresh-icon.svg"
export const homeIcon = "/static/images/home-icon.svg"
export const pencilIcon = "/static/images/pencil-icon.svg"
export const copyIcon = "/static/images/copy-icon.svg"
export const shareIcon = "/static/images/share-icon.svg"
export const downloadIcon = "/static/images/download-icon.svg"
export const startIcon = "/static/images/start-icon.svg"